export function formatDate(): void;
export function formatDate(date: Date | string | undefined | null): string;
export function formatDate(date?: Date | string | null) {
  if (!date) return;
  if (!(date instanceof Date)) date = new Date(date);
  return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
}

/**
 * Formats a given date object into a string suitable for filenames.
 * The resulting string will be in the format: YYYY-MM-DD_HH-MM-SS.
 *
 * @param {Date} date - The date object to be formatted.
 * @returns {string} A string representation of the date in the specified format.
 */
export const formatDateTimeForFilename = (date: Date): string => {
  const pad = (num: number): string => String(num).padStart(2, '0');

  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}_${pad(date.getHours())}-${pad(date.getMinutes())}-${pad(date.getSeconds())}`;
};